import React, { RefObject, useEffect, useRef, useState } from "react";
import { Card } from "react-bootstrap";
import { NumberOrderApi } from "../../../../../services/Api/Public/types";
import isElementClippingAnotherElement from "../../../../../utils/elements/isElementClippingAnotherElement";
import { getNumberSystemClassName } from "../utils";

interface Props {
	item: NumberOrderApi;
	parentRef: RefObject<HTMLDivElement>;
}

const getClippingClass = (itemRef: React.RefObject<HTMLDivElement>, parentRef: RefObject<HTMLDivElement>) => {
	if (!itemRef.current || !parentRef.current) return "opacity-0";

	return isElementClippingAnotherElement(itemRef.current, parentRef.current) ? "opacity-0" : "";
};

const NumberSystemCard = ({ item, parentRef }: Props) => {
	const itemRef = useRef<HTMLDivElement>(null);
	const [clippingClass, setClippingClass] = useState(getClippingClass(itemRef, parentRef));

	useEffect(() => {
		setClippingClass(getClippingClass(itemRef, parentRef));
	}, [itemRef, parentRef]);

	return (
		<Card className={`number-system-card ${getNumberSystemClassName(item)} ${clippingClass}`} ref={itemRef}>
			<Card.Body>
				<p>{item.order_number}</p>
			</Card.Body>
		</Card>
	);
};

export default NumberSystemCard;
